import networkTS from '@/misc/apis/networkTS'
import {
  AiadvertGenerationFeedbackRating,
  AiadvertGenerationGenerateResponse,
  AdvertGenerationSubmitGenerationFeedbackResponse
} from '@/types/api'
import { AxiosRequestConfig } from 'axios'

const GENERATION_TIMEOUT_MS = 180000

export default {
  async getAccountConfig(accountId: string) {
    return networkTS.advertGenerationServiceGetAccountConfig(accountId)
      .then((response) => {
        return response.data
      })
  },
  async setAccountConfig(accountId: string, prompt: string) {
    return networkTS.advertGenerationServiceSetAccountConfig(accountId, {
      prompt
    })
      .then((response) => {
        return response.data
      })
  },
  async generate(objectId: string, requestParams: AxiosRequestConfig = {}): Promise<AiadvertGenerationGenerateResponse> {
    return networkTS.advertGenerationServiceGenerate(
      { objectId },
      { timeout: GENERATION_TIMEOUT_MS, ...requestParams }
    ).then((response) => {
      return response.data
    })
  },
  async regenerate(generationId: string, feedback: string, requestParams: AxiosRequestConfig = {}): Promise<AiadvertGenerationGenerateResponse> {
    return networkTS.advertGenerationServiceRegenerate(
      { generationId, feedback },
      { timeout: GENERATION_TIMEOUT_MS, ...requestParams }
    ).then((response) => {
      return response.data
    })
  },
  async submitFeedback(
    generationId: string,
    rating: AiadvertGenerationFeedbackRating,
    comment?: string
  ): Promise<AdvertGenerationSubmitGenerationFeedbackResponse> {
    return networkTS.advertGenerationServiceSubmitGenerationFeedback({
      generationId,
      rating,
      comment
    }).then((response) => {
      return response.data
    })
  }
}
